import { isEmpty } from '../../../../../util/isEmpty'

/**
 * @description Concatenate any number of optional HTML report-text fragments,
 * dropping ones with no real content (empty string or empty HTML like `<p></p>`).
 * @returns the combined HTML, or '' if none of the inputs have content
 */
export const combineReportText = (...texts: Array<string | undefined>): string => {
  return texts.filter((text): text is string => !!text && !isEmpty(text)).join('')
}
